import React, { useState } from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import FormGroup from '@material-ui/core/FormGroup'
import FormLabel from '@material-ui/core/FormLabel'
import FormControl from '@material-ui/core/FormControl'
import OutlinedInput from '@material-ui/core/OutlinedInput'
import AdminAPI from 'config/api/AdminAPI'
import { NotificationManager } from 'react-notifications'
import { onError } from 'config/lib/errorLib'
import Loader from 'components/general/Loader'

function SendEmailModal({ open, onClose, companyDetails }) {
    const api = new AdminAPI()
    const [email, setEmail] = useState(companyDetails.primaryPerson ? companyDetails.primaryPerson.email : '')
    const [subject, setSubject] = useState('')
    const [body, setBody] = useState('')
    const [loading, setLoading] = useState(false)

    const sendEmail = async () => {
        setLoading(true)
        try {
            await api.sendAdminEmail(email, subject, body)
            NotificationManager.success('Email sent to ' + email)
            onClose()
        } catch (e) {
            onError(e)
        }
        setLoading(false)
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogContent>
                <Grid container>
                    <Grid item xs={12} style={{ marginBottom: '1rem' }}>
                        <Box component={Typography} variant='h3'>
                            Send Email to Provider
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <FormGroup>
                            <FormLabel>Recipient Email Address</FormLabel>
                            <FormControl variant='filled' fullWidth>
                                <OutlinedInput
                                    type='email'
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder='provider@example.com'
                                />
                            </FormControl>
                        </FormGroup>
                    </Grid>
                    <Grid item xs={12}>
                        <FormGroup>
                            <FormLabel>Subject</FormLabel>
                            <FormControl variant='filled' fullWidth>
                                <OutlinedInput
                                    value={subject}
                                    onChange={(e) => setSubject(e.target.value)}
                                />
                            </FormControl>
                        </FormGroup>
                    </Grid>
                    <Grid item xs={12}>
                        <FormGroup>
                            <FormLabel>Body</FormLabel>
                            <FormControl variant='filled' fullWidth>
                                <OutlinedInput
                                    multiline
                                    rows={6}
                                    value={body}
                                    onChange={(e) => setBody(e.target.value)}
                                />
                            </FormControl>
                        </FormGroup>
                    </Grid>
                    <Grid item xs={12}>
                        <Box display='flex' justifyContent='flex-end' mt={2}>
                            <Button
                                variant='outlined'
                                color='primary'
                                onClick={onClose}
                                style={{ marginRight: '1rem' }}
                                disabled={loading}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant='contained'
                                color='primary'
                                onClick={sendEmail}
                                disabled={!email || loading}
                            >
                                {loading ? <Loader height={12} /> : 'Send'}
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    )
}

export default SendEmailModal
